import React, { useState } from 'react';
import Button from '../../components/Button';
import Caret from '../../components/Caret';
import OverflowMenu from '../../components/OverflowMenu';
import * as styles from './SharingDropdownSelect.module.scss';

type SharingDropdownSelectProps = {
  label: string;
  ariaLabel: string;
  children: React.ReactNode;
  testId?: string;
};

const SharingDropdownSelect = ({
  label,
  children,
  testId,
  ariaLabel,
}: SharingDropdownSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <OverflowMenu
      onOpenChange={setIsOpen}
      open={isOpen}
      ariaLabel={ariaLabel}
      button={
        <Button testId={testId} className={styles.button} size="small">
          {label} <Caret direction={isOpen ? 'up' : 'down'} />
        </Button>
      }
      offset={{ crossAxis: 6 }}
    >
      {children}
    </OverflowMenu>
  );
};

export default SharingDropdownSelect;
